export enum ModuleType {
	CONTACT_KANBAN = 'CONTACT_KANBAN', // CONTACT_KANBAN
	MEETING_REPORT = 'MEETING_REPORT', // MEETING_REPORT
	ON_BOARDING = 'ON_BOARDING', // ON_BOARDING
	JOB_KANBAN = 'JOB_KANBAN', // JOB_KANBAN
	SYNTHESIS = 'SYNTHESIS', // SYNTHESIS
	LINKEDIN = 'LINKEDIN', // LINKEDIN
	GENERIC = 'GENERIC', // GENERIC
	MOSAIC = 'MOSAIC', // MOSAIC
	PITCH = 'PITCH', // PITCH
	PUSH = 'PUSH', // PUSH
}
